/**
 * Global utility functions & polyfills
 */

//Polyfill for startsWith for Internet Explorer
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
        return this.substr(position || 0, searchString.length) === searchString;
    };
}

//Cached version of jQuery getScript()
jQuery.cachedScript = function(url, async, options) {

  // Allow user to set any option except for dataType, cache, and url
  options = $.extend( options || {}, {
    cache: true,
    url: url,
    async: typeof async !== "undefined" ? async : true
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return jQuery.ajax( options );
};

//Responsive Breakpoints
var isTablet, isMobile900, isMobile;

if ($(document).width() <= 1024) {
    if ($(document).width() <= 900 && $(document).width() > 720) {
        isMobile900 = true;
    }
    if ($(document).width() > 720) {
        isTablet = true;
    } else {
        isMobile = true;
    }
}

//Returns the elements not in common between two arrays
Array.prototype.diff = function (a) {
    return this.filter(function (i) {
        return a.indexOf(i) < 0;
    });
};


/**
 * jQuery getScript() wrapper to support multiple script loading.
 */
$.getMultiScripts = function(arr, async) {
  var _arr = $.map(arr, function(src) {
    return $.cachedScript(src, async);
  });

  _arr.push($.Deferred(function( deferred ){
    $( deferred.resolve );
  }));

  return $.when.apply($, _arr);
}


/**
 * Module loader.
 */
var loader = (function () {
    var libs = {
        external: {
            modernizr: ACC.config.commonResourcePath + "/vendors/js/modernizr.min.js",
            slimscroll: ACC.config.commonResourcePath + "/vendors/js/jquery.slimscroll.min.js",
            owlcarousel: ACC.config.commonResourcePath + "/vendors/js/owl.carousel.min.js",
            cookie: ACC.config.commonResourcePath + "/vendors/js/jquery.cookie.min.js",
            form: ACC.config.commonResourcePath + "/vendors/js/jquery.form-3.09.min.js",
            tweetscroll: ACC.config.commonResourcePath + "/vendors/js/jquery.tweetscroll.min.js",
            isotope: ACC.config.commonResourcePath + "/vendors/js/isotope.pkgd.min.js",
            readmore: ACC.config.commonResourcePath + "/vendors/js/readmore.min.js",
            validationengine: ACC.config.commonResourcePath + "/vendors/js/jquery.validationEngine.min.js",
            validationengineLang: ACC.config.commonResourcePath + "/build/js/languages/jquery.validationEngine-"+ currentLanguage +".min" + GSEB.constants.staticResourcesVersionFile + ".js",
            dotdotdot: ACC.config.commonResourcePath + "/vendors/js/jquery.dotdotdot.min.js",
            floatthead: ACC.config.commonResourcePath + "/vendors/js/jquery.floatThead.min.js",
            cookiemanager: ACC.config.commonResourcePath + "/build/js/cookie.manager.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            mbytplayer: ACC.config.commonResourcePath + "/vendors/js/jquery.mb.YTPlayer.min.js",
            jQueryCheck: ACC.config.commonResourcePath + "/vendors/js/jquery.formStyler.min.js",
            iCheck: ACC.config.commonResourcePath + "/vendors/js/icheck.min.js",
            checkInView: ACC.config.commonResourcePath + "/vendors/js/jquery.checkinview.min.js",
            datepicker: ACC.config.commonResourcePath + "/vendors/js/jquery-ui.datepicker.min.js",
            imagesloaded: ACC.config.commonResourcePath + "/vendors/js/imagesloaded.min.js",
            markerClusterer: ACC.config.commonResourcePath + "/vendors/js/markerclusterer.min.js",
            datatablejs :ACC.config.commonResourcePath +"/vendors/js/jquery.dataTables.min.js"
        },
        modules: {
            mainOwlCarousel: ACC.config.commonResourcePath + "/build/js/modules/sliders/main-owl-moulinex.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            sliders: ACC.config.commonResourcePath + "/build/js/modules/sliders/sliders.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            slidersDotRead: ACC.config.commonResourcePath + "/build/js/modules/sliders/sliders-dot-read.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            processModal: ACC.config.commonResourcePath + "/build/js/modules/pdp/process-modal.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            cartPopup: ACC.config.commonResourcePath + "/build/js/modules/tunnel/cart-popup.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            storeLocator: ACC.config.commonResourcePath + "/build/js/modules/pdp/store-locator.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            productComparator: ACC.config.commonResourcePath + "/build/js/modules/comparator/product-comparator.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            scrollableTableCompare: ACC.config.commonResourcePath + "/build/js/modules/comparator/scrollabletablecompare.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            analytics: ACC.config.commonResourcePath + "/build/js/modules/common/analytics.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            modal: ACC.config.commonResourcePath + "/build/js/modules/common/modal.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            cookieManager: ACC.config.commonResourcePath + "/build/js/modules/common/cookie.manager.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            contactUs: ACC.config.commonResourcePath + "/build/js/modules/common/css.contactus.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            commonJS: ACC.config.commonResourcePath + "/build/js/modules/common/common.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            iCheck: ACC.config.commonResourcePath + "/build/js/modules/common/icheck.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            checkInView: ACC.config.commonResourcePath + "/build/js/modules/common/jquery.checkinview.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            datepicker: ACC.config.commonResourcePath + "/build/js/modules/common/datepicker.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            isotope: ACC.config.commonResourcePath + "/build/js/modules/common/isotope.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            readmore: ACC.config.commonResourcePath + "/build/js/modules/common/readmore.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            validationengine: ACC.config.commonResourcePath + "/build/js/modules/common/validationEngine.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            recipesugc: ACC.config.commonResourcePath + "/build/js/modules/recipes/recipesUGC.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            plpAjax: ACC.config.commonResourcePath + "/build/js/modules/plp/plp.ajax.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            productsDesignedForDataTable : ACC.config.commonResourcePath + "/build/js/modules/accessory/ProductsDesignedFor.min"+ GSEB.constants.staticResourcesVersionFile+".js"
        }
    };

    var loadedDeps = [];

    const MODULES = {
        ".special-offers-v2-main .moreInfo, .cookboardV2, .js-carousel, .mini-banner-slider, .page-RecipeHomePage, .recipe-product-list, .community-component ul, .features-slider, .master-owl-slider .owl-carousel, .slider-4, .scrollable-lame, .slider-5,.our-applications-carousel ul, .minishow, #CarouselDetailProduct, #ifuSelector, #ModalMedia, .community, .page-CartPage": {
            async: false,
            executable: [libs.modules.mainOwlCarousel, libs.modules.sliders],
            dependencies: [libs.external.owlcarousel, libs.external.imagesloaded]
        },
        ".social-news-slider": {
            async: false,
            executable: [libs.modules.mainOwlCarousel, libs.modules.slidersDotRead],
            dependencies: [libs.external.owlcarousel, libs.external.dotdotdot, libs.external.readmore]
        },
        ".page-productDetails #CarouselDetailProduct .thumbnails .thumbnail a": {
            executable: [libs.modules.processModal],
            dependencies: [libs.modules.processModal]
        },
        "#StoreLocator, .scroll-store, .pageType-ContentPage , .page-productDetails , .pageType-ProductPage": {
            executable: [libs.modules.storeLocator],
            dependencies: [libs.external.slimscroll]
        },
        ".product-comparator, .gocompare.v2": {
            executable: [libs.modules.productComparator],
            dependencies: [libs.external.jQueryCheck]
        },
        "#ScrollabeTableCompare": {
            executable: [libs.modules.scrollableTableCompare],
            dependencies: [libs.external.floatthead]
        },
        '.product-media, #ModalMedia .modal-body': {
            executable: [libs.modules.modal],
            dependencies: [libs.modules.modal]
        },
        '#remember-my-choice': {
            executable: [libs.modules.cookieManager],
            dependencies: [libs.modules.cookieManager]
        },
        '#AjaxContact, #ModalFeedback, #FullFormContact,#RequestFormContact': {
            executable: [libs.modules.contactUs],
            dependencies: [libs.external.validationengine, libs.external.validationengineLang, libs.modules.contactUs]
        },
        '#FormStockAlert, #globalMessages, #submitForgottenPassword, #addDocSelector, .claim, #addDocLanguage, .search-area-reparability .search form #search-filter_reparability, #search_form_reparability, #companionClubForm, #detachedPieceForm #productCode, .our-applications, #newLetterSubsModal, .offer-popin': {
            executable: [libs.modules.commonJS],
            dependencies: [libs.external.readmore]
        },
        'input[type=CHECKBOX]': {
            async: false,
            executable: [libs.modules.iCheck],
            dependencies: [libs.external.iCheck]
        },
        '.wrap-header': {
            executable: [libs.modules.checkInView],
            dependencies: [libs.external.checkInView]
        },
        '#offsetCollectionDate, #ModalMessage, #offsetReturnDate, #weekend, #freeDays, #dateCollecte, #dateRetour, .ui-widget-header a span': {
            executable: [libs.modules.datepicker],
            dependencies: [libs.external.datepicker]
        },
        '.special-offers-v2-container, .special-offers-v2-filters-mobile .filter': {
            executable: [libs.modules.isotope],
            dependencies: [libs.external.isotope]
        },
        '.features-slider .item, .wrap-cookboard, #ifuLanguage, .AjaxaReparabilityResult .detailReparability .refClaim, #search-filter_reparability, .AjaxaReparabilityResult, .notfound-reparable, #search_form_reparability': {
            executable: [libs.modules.readmore],
            dependencies: [libs.external.readmore]
        },
        '#ModalMessage, a.nostock, #ContactUsCountryFormContact, #FormStockAlert, #FormUserIds, #FormStockAlert, #FormStockAlert, [data-analytics-contactFormSubmit]': {
            executable: [libs.modules.validationengine],
            dependencies: [libs.external.validationengine, libs.external.validationengineLang]
        },
        '#brandRecipes, #ugcRecipes, .recipe-banner': {
            executable: [libs.modules.recipesugc]
        },
        "#plp-facets-section, #plp-results-section, #plp-pagination-section" : {
            executable: [libs.modules.plpAjax],
            dependencies: [libs.modules.productComparator]
        },
        ".productsDesignedFor": {
            async: false,
            executable: [libs.modules.productsDesignedForDataTable],
            dependencies: [libs.external.datatablejs]
        }
    };

    var loadDeps = function () {
        $.each(MODULES, function (selector, module) {
            if ($(selector).length) {
                var asyncLoad = typeof module.async !== "undefined" ? module.async : true;
                if (typeof module.dependencies !== "undefined") {
                    if (typeof module.executable !== "undefined") {
                        module.executable.map(function (item) {
                          $.getMultiScripts(module.dependencies.diff(loadedDeps), asyncLoad).done($.cachedScript(item, asyncLoad));
                        });
                    } else {
                      $.getMultiScripts(module.dependencies.diff(loadedDeps), asyncLoad);
                    }
                    loadedDeps = loadedDeps.concat(module.dependencies.diff(loadedDeps));
                } else if (typeof module.executable !== "undefined") {
                    module.executable.map(function (item) {
                        $.cachedScript(item, asyncLoad);
                    });
                }
            }
        });
    };

    return {
        loadDeps: loadDeps
    };

}());

loader.loadDeps();

